export class Youtube{
	
	static COVER_OFFSET = 200;
	
	static checkAccess(){
		Youtube.canAccess().then((result)=>{
			window.isYoutubeAccess = result;
		});
	}
	
	static async canAccess(){
		try {
			const request = await fetch(
				"https://www.youtube.com/",
				{
					mode: "no-cors"
				}
			);
			return true;
		} catch {
			return false;
		}
	}
	/*
	YTPlayerAPI呼び出しスクリプト生成
	 */
	static initTag(callBack){
		window.onYouTubeIframeAPIReady = callBack;
		var script =document.createElement('script');
		script.src = 'https://www.youtube.com/iframe_api';
			document.querySelector('head').appendChild(script);
	}
	
	/*
	wrapにCoverでiframeを表示
	 */
	static cover(wrap_selector,video_w,video_h){
		var w,h,top,left,scale,
			wrap,wrap_w,wrap_h,wrap_ratio,
			video_ratio,
			iframe
		
		wrap = document.querySelector(wrap_selector);
		wrap_w = wrap.offsetWidth;
		wrap_h = wrap.offsetHeight;
		wrap_ratio = wrap_w / wrap_h;
		video_ratio = video_w / video_h;
		if(wrap_ratio > video_ratio){
			w = wrap_w;
			scale = wrap_w / video_w;
			h = video_h * scale;
		}else{
			h = wrap_h;
			scale = wrap_h / video_h;
			w = video_w * scale;
		}
		h += Youtube.COVER_OFFSET;

		iframe = wrap.querySelector('iframe');
		iframe.style.width = w + 'px';
		iframe.style.height = h + 'px';
		iframe.style.top = '-'+((h - wrap_h) / 2) + 'px';
		iframe.style.left = '-'+((w - wrap_w) / 2) + 'px';
	}
	
}